// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"820":"c2233127","887":"d29f4d6d"}[chunkId] + ".chunk.js";
};